const EMPTY_VISIBLE_CHAT = Object.freeze({
	chatLastText: "",
	chatLastTextUser: "",
	chatLastTextTime: null,
	chatPinnedCount: 0,
	chatUnreadCount: 0,
	chatFollowUp: false
});

function toNonNegativeInteger(value) {
	const numberValue = Number(value);
	return Number.isFinite(numberValue) ? Math.max(0, Math.trunc(numberValue)) : 0;
}

export function normalizeStreamUnreadChannelId(unreadChannel = {}) {
	const rawChannelId = unreadChannel.channel_id
		|| unreadChannel.channel_cid
		|| unreadChannel.cid
		|| (unreadChannel.channel && (unreadChannel.channel.cid || unreadChannel.channel.id))
		|| "";
	const channelId = String(rawChannelId).trim();
	const channelTypeSeparator = channelId.indexOf(":");

	return channelTypeSeparator === -1
		? channelId
		: channelId.slice(channelTypeSeparator + 1);
}

export function getStreamChatUnreadBreakdown(unreadResponse = {}) {
	const unreadChannels = Array.isArray(unreadResponse.channels) ? unreadResponse.channels : [];
	let genericUnreadMessagesCount = 0;
	let jobUnreadMessagesCount = 0;

	unreadChannels.forEach(unreadChannel => {
		const channelId = normalizeStreamUnreadChannelId(unreadChannel);
		const unreadCount = toNonNegativeInteger(unreadChannel && unreadChannel.unread_count);

		if (!channelId || unreadCount === 0) {
			return;
		}

		if (channelId.indexOf("instance-") === 0) {
			jobUnreadMessagesCount += unreadCount;
		} else if (channelId.indexOf("ai-dm-") !== 0) {
			genericUnreadMessagesCount += unreadCount;
		}
	});

	return {
		genericUnreadMessagesCount,
		jobUnreadMessagesCount
	};
}

export function resolveJobChatUnreadCount({
	exactUnreadCount,
	totalUnreadCount,
	allowTotalFallback = false
} = {}) {
	if (Number.isFinite(exactUnreadCount)) {
		return toNonNegativeInteger(exactUnreadCount);
	}

	return allowTotalFallback && Number.isFinite(totalUnreadCount)
		? toNonNegativeInteger(totalUnreadCount)
		: 0;
}

export function getVisibleChatInstanceIds(hits = []) {
	const seen = new Set();
	const instanceIds = [];

	(Array.isArray(hits) ? hits : []).forEach(hit => {
		const instanceId = String(hit && hit.instanceId !== undefined && hit.instanceId !== null
			? hit.instanceId
			: "").trim();
		if (!instanceId || seen.has(instanceId)) {
			return;
		}

		seen.add(instanceId);
		instanceIds.push(instanceId);
	});

	return instanceIds;
}

export function buildVisibleJobChatState(instanceIds = [], channels = []) {
	const normalizedInstanceIds = Array.isArray(instanceIds)
		? instanceIds.map(instanceId => String(instanceId || "").trim()).filter(Boolean)
		: [];
	const nextChat = {};
	const stateKeyByChannelId = new Map();

	normalizedInstanceIds.forEach(instanceId => {
		nextChat[instanceId] = { ...EMPTY_VISIBLE_CHAT };
		stateKeyByChannelId.set(instanceId, instanceId);
		stateKeyByChannelId.set(instanceId.indexOf("instance-") === 0 ? instanceId : `instance-${instanceId}`, instanceId);
	});

	(Array.isArray(channels) ? channels : []).forEach(channel => {
		const rawChannelId = String((channel && (channel.id || channel.cid)) || "").trim();
		const channelId = rawChannelId.indexOf(":") === -1
			? rawChannelId
			: rawChannelId.slice(rawChannelId.indexOf(":") + 1);
		const stateKey = stateKeyByChannelId.get(channelId);
		if (!stateKey) {
			return;
		}

		const messageSet = channel && channel.state && Array.isArray(channel.state.messageSets)
			? channel.state.messageSets[0]
			: null;
		const messages = messageSet && Array.isArray(messageSet.messages)
			? messageSet.messages
			: (channel && channel.state && Array.isArray(channel.state.messages) ? channel.state.messages : []);
		const latestMessage = messages.length > 0 ? messages[messages.length - 1] : null;

		nextChat[stateKey] = {
			chatLastText: latestMessage && latestMessage.text ? latestMessage.text : "",
			chatLastTextUser: latestMessage && latestMessage.user && latestMessage.user.name ? latestMessage.user.name : "",
			chatLastTextTime: latestMessage && latestMessage.created_at ? latestMessage.created_at : null,
			chatPinnedCount: channel && channel.state && Array.isArray(channel.state.pinnedMessages)
				? channel.state.pinnedMessages.length
				: 0,
			chatUnreadCount: toNonNegativeInteger(channel && channel.state && channel.state.unreadCount),
			chatFollowUp: false
		};
	});

	return nextChat;
}
